<template>
  <div class="ctrl-notifications">
    <h2>全体連絡 一覧</h2>
    <NotificationList />
  </div>
</template>

<script>
// 
import NotificationList from '@/components/Ctrl/Notifications/NotificationList.vue'

// 
export default {
  data() {
    return {};
  },
  components: {
    NotificationList
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
